import bolt11 from '../utils/bolt11';

/**
 * Docs: https://docs.lightning.engineering/the-lightning-network/payment-lifecycle/understanding-lightning-invoices
 * Validation is based from this link: https://github.com/bitcoincoretech/bolt11-ui/blob/main/lib/bolt11.js
 * Sample UI Validation: https://bitcoincore.tech/apps/bolt11-ui/index.html
 * 
 * @param {string} address 
 * @returns boolean
 */
function validateLightningInvoice(address) {
  try {
    return bolt11.decode(address);
  } catch (e) {
    return false;
  }
}

export default {
  isValidAddress(address, currency, networkType) {
    return validateLightningInvoice(address);
  },
};
